import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";
import Icon from "@shared/components/Icon";
import Box from "@mui/material/Box";
import Surtitle from "@project/components/Surtitle";
const DescriptionSection = (props) => {
    const { id, title, subtitle, description, image, backgroundColor, style, orientation, dynamicList = [], ...others } = props;
    return (_jsxs(Stack, { component: "section", spacing: 4, sx: {
            ...(backgroundColor && { background: backgroundColor, p: 5 }),
        }, ...others, children: [_jsxs(Stack, { spacing: 2, children: [title && _jsx(Surtitle, { title: title }), subtitle && (_jsx(Typography, { variant: "h3", component: "p", children: subtitle }))] }), description && (_jsx(Typography, { variant: "subtitle2", component: "p", sx: { fontSize: "18px", maxWidth: 690 }, children: description })), style === "text" ? (_jsxs(Stack, { direction: { xs: "column", md: "row" }, spacing: 5, useFlexGap: true, sx: {
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                }, children: [_jsx(Stack, { direction: orientation === "vertical"
                            ? "column"
                            : { xs: "column", md: "row" }, spacing: 2.5, children: dynamicList?.map((item, index) => (_jsx(Box, { sx: {
                                borderLeft: "2px solid",
                                borderColor: "#3E3E3E",
                                py: 0.5,
                            }, children: _jsxs(Stack, { spacing: 1.5, sx: {
                                    pl: 5,
                                }, children: [_jsx(Typography, { variant: "subtitle1", component: "p", children: item.title }), _jsx(Typography, { variant: "subtitle2", component: "p", children: item.description })] }, (item.title || "") + index) }, (item.title || "") + index))) }), image?.url && (_jsx(Box, { component: "img", src: image.url, alt: "", sx: {
                            maxWidth: 304,
                            width: "100%",
                            marginX: { xs: "auto !important", md: "initial !important" },
                        } }))] })) : (_jsxs(Stack, { direction: { xs: "column", md: "row" }, spacing: 5, useFlexGap: true, sx: {
                    flexWrap: "wrap",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                }, children: [_jsx(Stack, { direction: orientation === "vertical"
                            ? "column"
                            : { xs: "column", md: "row" }, spacing: 3, useFlexGap: true, sx: {
                            flexWrap: "wrap",
                            alignItems: "center",
                            justifyContent: "center",
                        }, children: dynamicList?.map((item, index) => (_jsxs(Card, { borderColor: backgroundColor ? "white" : "text.primary", children: [item.icon && item.icon?.icon && (_jsx(Box, { className: "card-icon", sx: {
                                        position: "relative",
                                        zIndex: 1,
                                        "& > *": {
                                            borderRadius: "initial !important",
                                            fontSize: "22px",
                                            width: "22px !important",
                                            height: "22px !important",
                                        },
                                    }, children: _jsx(Icon, { ...item.icon }) })), _jsxs(Stack, { spacing: 1.5, children: [item.title && (_jsx(Typography, { variant: "subtitle1", component: "p", children: item.title })), item.description && (_jsx(Typography, { variant: "subtitle2", component: "p", children: item.description }))] })] }, (item.title || "") + index))) }), image?.url && (_jsx(Box, { component: "img", src: image.url, alt: "", sx: {
                            maxWidth: 304,
                            width: "100%",
                            marginX: { xs: "auto !important", md: "initial !important" },
                        } }))] }))] }, id));
};
const Card = ({ children, borderColor, }) => {
    return (_jsx(Stack, { spacing: 1, sx: {
            width: "100%",
            maxWidth: 344,
            backgroundColor: "transparent",
            border: "1px solid",
            borderColor,
            p: 3,
        }, children: children }));
};
export default DescriptionSection;
